import { Box } from '@mui/material';
import React from 'react';

import logoIconOnlyWhite from 'assets/logo-icon-only-white.svg';
import logoIconOnly from 'assets/logo-icon-only.svg';
import logoWhite from 'assets/logo-white.svg';
import logo from 'assets/logo.svg';

// TODO: Add typings
const Logo = ({ sx = {}, iconOnly = false, white = false }) => (
    <Box
        component='img'
        // eslint-disable-next-line no-nested-ternary
        src={iconOnly ? (white ? logoIconOnlyWhite : logoIconOnly) : white ? logoWhite : logo}
        sx={{ height: 42, ...sx }}
    />
);

export default Logo;
